/*
 * @Description: 
 * @Autor: lizi
 * @Date: 2019-09-30 14:48:30
 * @LastEditors: lizi
 * @LastEditTime: 2022-07-18 15:14:50
 * @FilePath: \registration-system-web\src\config\GlobalText.js
 */
// 全局的文字
export const platformName = '线上报名系统';

//分页条数
export const PAGE_SIZE = 10;
